<template>
  <div class="text-center banner-box">

    <div class="company-name  text-white"> {{ $t('banner.company_name') }}</div>
    <div class="company-tagline1 text-white text-shadow">
      {{ $t('banner.tagline1') }}&nbsp; &nbsp;{{ $t('banner.tagline2') }}
    </div>
    <div class="company-tagline text-white">
      {{ $t('banner.tagline3') }}
    </div>
  </div>
</template>

<style scoped>
.banner-box {
  margin-top: -100px;
}

/* Refined banner typography for international business style */
.company-name {
  font-size: 32px; /* first line - medium size */
  font-weight: 500;
  /* text-transform: uppercase;*/
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.9);
  max-width: 90%;
  animation: fadeInUp 700ms cubic-bezier(.25, .8, .25, 1) 120ms both;
  position: relative;
}

.company-tagline1 {
  font-size: 44px; /* second line - largest size */
  font-weight: 700;
  line-height: 1.2;
  margin: 40px 0 30px; /* increased spacing between second and third line */
  letter-spacing: 0.5px;
  animation: fadeInUp 700ms cubic-bezier(.25, .8, .25, 1) 220ms both;
  /* premium gold gradient for international business look */
/*  background: linear-gradient(90deg,#fff,#ffe696e6);*/
  background: #ffe696e6;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.company-name::after {
  content: "";
  display: none;
  width: 180px; /* wider divider for better balance */
  height: 2px; /* thinner for elegance */
  background: rgba(255, 215, 0, 0.8); /* gold accent */
  border-radius: 2px;
  margin: 20px auto 0; /* increased spacing for divider */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.company-tagline {
  font-size: 40px; /* third line - between first and second in size */
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.3px;
  animation: fadeInUp 850ms cubic-bezier(.25, .8, .25, 1) 320ms both;
}

.text-shadow {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .banner-box {
    margin-top: -40px;
    padding: 0 12px;
  }

  .company-tagline1 {
    font-size: 24px;
    letter-spacing: 1.2px;
    margin: 20px 0 15px;
    line-height: 1.3;
  }

  .company-name {
    font-size: 22px;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  .company-tagline {
    font-size: 20px;
    max-width: 95%;
    line-height: 1.3;
  }

  .company-name::after {
    width: 60px;
    margin: 12px auto 0;
  }
}

@media (max-width: 600px) {
  .banner-box {
    margin-top: 0;
    padding: 0 16px;
  }

  .company-tagline1 {
    font-size: 17px;
    letter-spacing: 0.5px;
    margin: 10px 0 8px;
    line-height: 1.4;
    word-wrap: break-word;
    white-space: normal;
  }

  .company-name {
    font-size: 21px;
    margin-bottom: 0.6rem;
    line-height: 1.4;
    letter-spacing: 1px;
    word-wrap: break-word;
    white-space: normal;
  }

  .company-tagline {
    font-size: 17px;
    margin-bottom: 0;
    max-width: 100%;
    line-height: 1.4;
    word-wrap: break-word;
    white-space: normal;
  }

  .company-name::after {
    width: 50px;
    margin: 8px auto 0;
  }

  .text-center {
    padding: 0 8px;
  }
}

</style>
<script setup lang="ts">
</script>